import React from "react";
import {Box} from "@unibuddy/patron";
import {Trans, useTranslation} from "@unibuddy/intl";

import EmptyState from "../../../General/components/EmptyState/EmptyState";
import image from "./empty_inbox.svg";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_WATCH_THIS_SPACE_MESSAGE} from "../../../../translations/inbox";

export function InboxEmpty() {
    const {t} = useTranslation(IntlNamespaces.INBOX);

    return (
        <Box data-test-id="inbox-empty">
            <EmptyState
                image={
                    <Box marginY="medium">
                        <img height="80%" src={image} alt="Empty state" />
                    </Box>
                }
                text={
                    <span>
                        <Trans i18nKey={INTL_WATCH_THIS_SPACE_MESSAGE.key} t={t}>
                            {INTL_WATCH_THIS_SPACE_MESSAGE.defaultValue}
                        </Trans>
                    </span>
                }
            />
        </Box>
    );
}
